export const getTimeLeft = (date) => {
    if (!date) {
        return date;
    }

    return new Date(date) - Date.now();
};
